import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 懒加载页面组件
const routes = [
    // 核心页面（菜单跳转对应路由）
    { path: '/', name: 'Home', component: () => import('@/pages/home/Index') },
    { path: '/about', name: 'About', component: () => import('@/pages/about/Index') },
    { path: '/services', name: 'ServiceList', component: () => import('@/pages/service/List') },
    { path: '/consults', name: 'ConsultList', component: () => import('@/pages/consult/List') },
    { path: '/posts', name: 'PostList', component: () => import('@/pages/post/List') },

    // 详情页
    { path: '/service/:id', name: 'ServiceDetail', component: () => import('@/pages/service/Detail') },
    { path: '/consult/:id', name: 'ConsultDetail', component: () => import('@/pages/consult/Detail') },
    { path: '/post/:id', name: 'PostDetail', component: () => import('@/pages/post/Detail') },

    // 登录注册
    { path: '/login', name: 'Login', component: () => import('@/pages/auth/Login') },
    { path: '/register', name: 'Register', component: () => import('@/pages/auth/Register') },

    // 用户中心（需要登录）
    {
        path: '/user',
        redirect: '/user/profile',
        meta: { requireAuth: true },
        children: [
            { path: 'profile', name: 'UserProfile', component: () => import('@/pages/user/Profile') },
            { path: 'post/edit', name: 'PostEdit', component: () => import('@/pages/user/PostEdit') }
        ]
    },

    // 管理员后台（需要管理员权限）
    { path: '/admin/login', name: 'AdminLogin', component: () => import('@/pages/admin/Login') },
    {
        path: '/admin',
        redirect: '/admin/dashboard',
        meta: { requireAdmin: true },
        children: [
            { path: 'dashboard', name: 'AdminDashboard', component: () => import('@/pages/admin/Dashboard') },
            { path: 'user', name: 'AdminUser', component: () => import('@/pages/admin/User') }
        ]
    },

    // 404页面（兜底）
    { path: '*', redirect: '/' }
]

const router = new Router({
    mode: 'history',  // 去掉URL中的#，可选（如果本地测试有问题可改为hash）
    routes
})

// 路由守卫 - 权限控制
router.beforeEach((to, from, next) => {
    const userToken = localStorage.getItem('userToken')
    const adminToken = localStorage.getItem('adminToken')

    // 需要登录但未登录
    if (to.meta.requireAuth && !userToken) {
        this.$message.warning('请先登录') // 修复：这里改为Vue实例调用
        return next({ path: '/login', query: { redirect: to.fullPath } }) // 登录后返回原页面
    }

    // 需要管理员权限但未登录
    if (to.meta.requireAdmin && !adminToken) {
        this.$message.warning('请以管理员身份登录')
        return next('/admin/login')
    }

    next()
})

export default router
